<template>
  <div>
    <Layout/>
    <h4>Roles de Usuarios</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idRol" class="form-label">IdRol</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idRol" name="idRol" v-model="datoRol.idRol" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoRol.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarRol" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarRol" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditRol" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdRolModu</th>
          <th scope="col">IdRol</th>
          <th scope="col">IdModulo</th>
          <th scope="col">Estado</th>
          <th scope="col">RolNombre</th>
          <th scope="col">ModuloNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="rolmodu in datosPaginados" :key="rolmodu.idRolModu">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(rolmodu.idRolModu)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(rolmodu.idRolModu)" title="Editar">edit_square</i></td>
          <td>{{rolmodu.idRolModu}}</td>
          <td>{{rolmodu.idRol}}</td>
          <td>{{rolmodu.idModulo}}</td>
          <td>{{rolmodu.estado}}</td>
          <td>{{rolmodu.rolNombre}}</td>
          <td>{{rolmodu.moduloNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteRol(rolmodu.idRolModu)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idRolModu" class="form-label">IdRolModu</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idRolModu" name="idRolModu" v-model="datoRolModu.idRolModu" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idRol" class="form-label">IdRol</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idRol" name="idRol" v-model="datoRolModu.idRol" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idModulo" name="idModulo" v-model="datoRolModu.idModulo"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idModulo" class="form-label"> Modulo</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="modulo" name="modulo" v-model="datoRolModu.modulo" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalModuloLOV"
                      title="Buscar Módulos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarRolModu" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditRolModu" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: RolModu -->
    <RolModuLOVdet @DatosRolModu="GetDataRolModuLOVdet($event)"/>
<!-- Lista de Valores: Modulo -->
    <ModuloLOVdet @DatosModulo="GetDataModuloLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import RolModuLOVdet from '../../components/lovs/RolModuLOV.vue'
import ModuloLOVdet from '../../components/lovs/ModuloLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, RolModuLOVdet
, ModuloLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      rols : [],
      datoRol : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idRol: '',
// Variables master
// Variables details
      rolmodus : [],
      datoRolModu : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idRol = this.$route.params.p_idrol
    this.abrirEditar(this.p_idRol)
    this.getRolModus()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoRol.idRol === ''){
        swal("Error!", "El elemento idRol no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoRol.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoRol.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarRol(){
      if(this.validarForm() === 1){
        try {
          await api.post('/rols', this.datoRol)
          swal("Correcto!", "Rol creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditRol(){
      if(this.validarForm() === 1){
        try {
          await api.post('/rols', this.datoRol)
          swal("Correcto!", "Rol creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoRol={}
      this.titulo   = 'Crear Roles de Usuarios'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idRol){
      this.modalWindow = true
      if(idRol != null){    
           api.get('/vwrols/'+idRol).then(resp=>{
          this.datoRol = resp.data;
           });
      }
      this.titulo   = 'Editar Roles de Usuarios'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarRol(){
      this.$router.push('/Rol')
    },
// Procedimientos master
// Procedimientos detalle
    async getRolModus() {
      const resp = await api.get('/rolmodus')
      this.rolmodus = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.rolmodus.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwrolmodus/nombre/'+this.nombreBusqueda).then(response=>{
          this.rolmodus=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.rolmodus.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwrolmodus').then(response=>{
      this.rolmodus=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.rolmodus.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoRolModu.idRol === ''){
        swal("Error!", "El elemento idRol no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoRolModu.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoRolModu.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarRolModu(){
      if(this.validarForm() === 1){
        try {
          this.datoRolModu.idRol = this.datoRol.idRol;
          await api.post('/rolmodus', this.datoRolModu)
          this.getRolModus();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "RolModu creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditRolModu(){
      if(this.validarForm() === 1){
        try {
          await api.post('/rolmodus', this.datoRolModu)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "RolModu creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoRolModu={}
      this.titulo   = 'Crear Roles de Usuarios'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idRolModu){
      this.modalWindow = true
      if(idRolModu != null){    
           api.get('/vwrolmodus/'+idRolModu).then(resp=>{
          this.datoRolModu = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Roles de Usuarios'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idRolModu){
      this.modalWindow = true
      if(idRolModu != null){
        this.$router.push('/rolmodumd/'+idRolModu)
      }
    },
    async deleteRolModu (idRolModu) {
      try{
        await api.delete('/rolmodus/'+idRolModu)
          this.getRolModus()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataRolModuLOVdet(data) {
      this.datoRolModu.idRolModu = data.idRolModu;
      this.datoRolModu.rolModu = data.nombre;
    },
//    Lista de Valores
    GetDataModuloLOVdet(data) {
      this.datoRolModu.idModulo = data.idModulo;
      this.datoRolModu.modulo = data.nombre;
    },
// Listas de valores details
  },
}
</script>
